import { useTranslation } from 'react-i18next'
import { useVersionMismatch } from '@shared/hooks/useVersionMismatch'
import { dismissVersion } from '@store/versionStore'
import { auxaliaColors } from '@shared/theme'

export function VersionMismatchToast() {
  const { t } = useTranslation()
  const { isMismatch, latestVersion } = useVersionMismatch()

  if (!isMismatch || !latestVersion) return null

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1100,
        background: auxaliaColors.white,
        border: `1px solid ${auxaliaColors.grayLight}`,
        borderRadius: 10,
        boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        maxWidth: 380,
        fontSize: 13,
      }}
    >
      <button
        type="button"
        aria-label={t('version.mismatch.refresh')}
        onClick={() => window.location.reload()}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          flex: 1,
          padding: 0,
          textAlign: 'left',
          fontSize: 13,
        }}
      >
        <span style={{ fontSize: 18 }}>🔄</span>
        <span style={{ color: auxaliaColors.textPrimary }}>
          {t('version.mismatch.message')}
        </span>
      </button>
      <button
        type="button"
        aria-label={t('version.mismatch.dismiss')}
        onClick={() => dismissVersion(latestVersion)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: auxaliaColors.grayMedium,
          fontSize: 16,
          lineHeight: 1,
          padding: 2,
        }}
      >
        ✕
      </button>
    </div>
  )
}
